import React, { createContext, memo, useState, useEffect } from 'react';
import firebase from 'firebase/app';
import * as firebaseUI from 'firebaseui';
export var store = createContext({ uiConfig: undefined, instance: undefined });
var Provider = store.Provider;
export var FirebaseProvider = memo(function (_a) {
    var config = _a.config, uiConfig = _a.uiConfig, name = _a.name, children = _a.children;
    var _b = useState(), fbInstance = _b[0], setFbInstance = _b[1];
    var _c = useState({ uiConfig: undefined, instance: undefined }), fb = _c[0], setFb = _c[1];
    useEffect(function () {
        setFbInstance(firebase.initializeApp(config, name));
    }, [config, name]);
    useEffect(function () {
        if (fbInstance) {
            var auth = fbInstance.auth();
            var firestore = fbInstance.firestore();
            var storage = fbInstance.storage().ref();
            firestore.enablePersistence()
                .catch(function (err) {
                if (err.code === 'failed-precondition') {
                    alert('Multiple tabs open, persistence can only be enabled in one tab at a a time.');
                }
                else if (err.code === 'unimplemented') {
                    alert('The current browser does not support all of the features required to enable persistence.');
                }
            });
            var instance = {
                auth: auth,
                ui: new firebaseUI.auth.AuthUI(fbInstance.auth(), name),
                storage: storage,
                pageDrive: storage.child('page'),
                blockDrive: storage.child('block'),
                firestore: firestore,
                Timestamp: firebase.firestore.Timestamp,
                account: firestore.collection('user'),
                pages: firestore.collection('pages'),
                blocks: firestore.collection('blocks'),
                settings: firestore.collection('settings')
            };
            auth.useDeviceLanguage();
            setFb({ uiConfig: uiConfig, instance: instance });
        }
    }, [uiConfig, fbInstance]);
    return (React.createElement(Provider, { value: fb }, children));
});
